import { COLORS, TYPOGRAPHY } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

const maxWidthSection = '850px';

const styleSheet = createStyleSheet({
  wrapper: {
    width: '100%',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '24px',
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: '64px',
    marginBottom: '24px',
  },
  language: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
  },
  translateGoogleSection: {
    width: '100%',
    maxWidth: maxWidthSection,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: maxWidthSection,
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    width: '100%',
    padding: '24px',
    border: `1px solid ${COLORS.BLUE_GRAY_MEDIUM.DEFAULT}`,
    borderRadius: '8px',
    margin: '24px',
  },
  sectionTitle: {
    ...TYPOGRAPHY.H3,
  },
  inputContainer: {
    width: '100%',
  },
  inputs: {
    display: 'flex',
    width: '100%',
    gap: '32px',
    maxWidth: maxWidthSection,
    height: '100%',
    marginBottom: '12px',
  },
});

export default styleSheet;
